export default "__VITE_ASSET__vy_WFiCq__"